import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "global-header" }

import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "brand",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "logo-mark" }, "OJ", -1),
      _createElementVNode("div", { class: "title" }, "OJ 在线判题系统", -1)
    ]))])
  ]))
}
}

})